<template>
  <div id="orderDetailPage" v-if="value!==undefined">
    <div id="printBtn" class="flex-end" style="margin-bottom:12px" v-if="isInternalPlugin('order_detail_print')">
      <button class="button is-primary" @click="printOrder($refs.orderDetail)">인쇄하기</button>
    </div>
    <div ref="orderDetail">
      <div class="columns is-multiline">
        <div class="column is-6">
          <div class="box">
            <admin-box-item title="주문 정보">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item :isFlex="true" label="주문 번호">{{ value.order_num }}</admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item :isFlex="true" label="주문 일자">{{ value.created_time }}</admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item :isFlex="true" label="배송 일자/시간대">{{ value.hope_day }}</admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item :isFlex="true" label="주문자">{{ value.name }}</admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
        </div>
        <div class="column is-6">
          <div class="box">
            <admin-box-item title="주문자 정보">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item :isFlex="true" label="주문자명(ID)">{{ value.name }}({{ value.email }})</admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item :isFlex="true" label="이메일">{{ value.email }}</admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item :isFlex="true" label="휴대전화">{{ value.phone }}</admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
        </div>

        <div class="column is-full">
          <div class="box">
            <admin-box-item title="주문 상품 정보">
              <!-- 탭 -->
              <tab :value.sync="tab"
                   style="margin-top:-20px"
                   :options="tabArr"
                   @update:value="selectTab"></tab>
              <div style="margin-top:10px" v-if="partnerName">
              제공: {{ partnerName }}
              </div>
              <admin-form-item label="주문 상품" style="margin-top:12px">
                <table class="delivery-orderproduct-table">
                  <thead>
                    <tr>
                      <!--<th style="width:5%">
                        <lp-check-bool :checkedVal.sync="check" @onCheck="clickCheckBoxAll"></lp-check-bool>
                      </th>-->
                      <th style="width:5%">상품 코드</th>
                      <th style="width:10%">상품 주문 번호</th>
                      <th style="width:25%">주문 상품</th>
                      <th style="width:10%">상품 금액</th>
                      <th style="width:5%">수량</th>
                      <th style="width:10%">상품별 금액</th>
                      <th style="width:10%">할인 금액</th>
                      <th style="width:10%">배달비</th>
                      <th style="width:10%">주문 상태</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(op,idx) in order_product" :key="'op-'+idx">
                      <td style="width:5%">{{ op.code?op.code:'-' }}</td>
                      <td style="width:10%">{{ op.id }}</td>
                      <td style="width:25%">
                        <div class="flex">
                          <div style="text-align: center;display: inline-block"
                               :style="thumbImgField(op.product.img)" v-if="op.product.img"></div>
                          <div style="text-align: left">
                            <div v-if="op.order_product_option.length>0">
                              <div>{{ op.product.name }}</div>
                              <div style="color:#C1C1C1;font-size:14px"
                                   v-for="(option, option_idx) in op.order_product_option"
                                   :key="'option-'+option_idx">
                                <span v-if="option.option.option_type===0">기본옵션:</span>
                                <span v-if="option.option.option_type===1">추가옵션:</span>
                                {{ option.option.name }} {{ option.option.price | currency }} X {{ option.quantity }}
                              </div>
                            </div>
                            <div v-else>
                              {{ op.product.name }} {{ op.quantity }}개
                            </div>
                          </div>
                        </div>

                      </td>
                      <td style="width:10%">
                        <div v-if="op.discount_price>0">
                          <div>{{ (op.product_price - op.discount_price / op.quantity) | currency }}</div>
                          <div style="text-decoration: line-through;">{{ op.product_price | currency }}</div>
                        </div>
                        <div v-else>{{ op.product_price | currency }}</div>
                      </td>
                      <td style="width:5%">{{ op.quantity }}</td>
                      <td style="width:10%">{{ op.product_price * op.quantity | currency }}</td>
                      <td style="width:10%">{{ op.discount_price | currency }}</td>
                      <td style="width:10%" :rowspan="order_product.length" v-if="idx===0">{{ value.delivery_cost | currency }}</td>
                      <td style="width:10%">{{ op.status_kor }}</td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr class="table-result">
                      <td colspan="4">계</td>
                      <td>{{ calcQuantity }}</td>
                      <td>{{ calcProductPrice | currency }}</td>
                      <td>{{ calcDiscountPrice | currency }}</td>
                      <td colspan="2"></td>
                    </tr>
                  </tbody>
                </table>
              </admin-form-item>

              <div class="btn-group-justify-end" v-if="tab===0 && order_product.length>0">
                <button class="button" v-if="$route.query.page==='OrderListOrder'" @click="changeStatus(101)">입금완료 처리</button>
                <button class="button" v-else-if="$route.query.page==='OrderListPayNew'" @click="changeStatus(200)">상품준비중 처리</button>
  <!--              <button class="button" v-else-if="$route.query.page==='OrderListGoodsNew'" @click="changeStatus(200)">상품준비중 처리</button>-->
                <button class="button" v-else-if="$route.query.page==='OrderListGoodsAll'" @click="changeStatus(300)">배달대기 처리</button>
                <button class="button" v-else-if="$route.query.page==='OrderListDeliveryNew'" @click="changeStatus(301)">배달중 처리</button>
                <button class="button" v-else-if="$route.query.page==='OrderListDeliverying'" @click="changeStatus(302)">배달 완료 처리</button>
                <button class="button" style="margin-left:8px" @click="$modal.show('orderDetailCancelModal')">주문 취소</button>
              </div>

              <div class="btn-group-justify-end" v-if="tab===1 && order_product.length>0">
                <button class="button" @click="openRefundModal">환불 처리</button>
              </div>
            </admin-box-item>
          </div>
        </div>

        <div class="column is-full" v-if="value.refund.length>0">
          <div class="box">
            <admin-box-item title="환불 정보">
              <refund-info :refund_id="refund_id"
                           :order="value"
                           v-for="(refund_id, idx) in value.refund" :key="`refund-${idx}`"></refund-info>
            </admin-box-item>
          </div>
        </div>

        <div class="column is-full">
          <div class="box">
            <admin-box-item title="결제 정보">
              <div class="columns is-multiline">
                <div class="column is-4">
                  <table class="delivery-order-info">
                    <tbody>
                    <tr>
                      <td class="order-info-title">총 주문 금액</td>
                      <td>{{ value.product_price | currency }}</td>
                    </tr>
                    <tr>
                      <td class="order-info-title">배달비</td>
                      <td>{{ value.delivery_cost | currency }}</td>
                    </tr>
                    <tr>
                      <td class="order-info-title">할인 금액</td>
                      <td>{{ value.discount_price | currency }}</td>
                    </tr>
                    <tr>
                      <td class="order-info-title">적립금</td>
                      <td>{{ value.point | currency }}</td>
                    </tr>
                    <tr>
                      <td class="order-info-title">쿠폰</td>
                      <td>{{ value.coupon_price | currency }}</td>
                    </tr>
                    <tr>
                      <td class="order-info-title">실 결제 금액</td>
                      <td>{{ value.total_price | currency }}</td>
                    </tr>
                    <tr v-if="isCard">
                      <td class="order-info-title">부분 취소 금액</td>
                      <td>{{ value.cancel_price | currency }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="column is-8">
                  <table class="delivery-order-info">
                    <tbody>
                    <tr>
                      <td class="order-info-title">결제 수단</td>
                      <td>{{ value.pay_type_kor }}</td>
                    </tr>
                    <!-- 카드 결제 -->
                    <tr v-if="value.pay_type===0">
                      <td class="order-info-title">결제 카드 정보</td>
                      <td>
                        카드사:
                        <span v-if="value.pg_result.CARD_PurchaseName">{{ value.pg_result.CARD_PurchaseName }}</span>
                        <span v-else-if="value.pg_result.P_TID">{{ value.pg_result.P_CARD_PURCHASE_NAME }}</span>
                        <br>
                        TID:
                        <span v-if="value.pg_result.tid">{{ value.pg_result.tid }}</span>
                        <span v-else-if="value.pg_result.P_TID">{{ value.pg_result.P_TID }}</span>
                      </td>
                    </tr>
                    <tr v-if="value.pay_type===0">
                      <td class="order-info-title">카드 결제 상세 내역</td>
                      <td>카드결제: {{ payDate }} /
                        <span v-if="value.pg_result.TotPrice">{{ value.pg_result.TotPrice | currency }}</span>
                        <span v-else-if="value.pg_result.P_TID">{{ value.pg_result.P_AMT | currency }}</span>
                      </td>
                    </tr>
                    <tr v-if="value.pay_type===4">
                      <td class="order-info-title">가상 계좌 정보</td>
                      <td v-if="value.pg_result.VACT_Num">
                        <div v-if="value.pg_result.VACT_Num">계좌번호: {{ value.pg_result.VACT_Num }}</div>
                        <div v-if="value.pg_result.vactBankName">은행명: {{ value.pg_result.vactBankName }}</div>
                        <!--                        <div v-if="value.pg_result.MOID">이니시스 주문번호: {{ value.pg_result.MOID }}</div>-->
                        <div v-if="value.pg_result.VACT_Date">
                          입금 기한: {{ convertDate(value.pg_result.VACT_Date, 'date') }}까지</div>
                      </td>
                      <td v-if="value.pg_result.P_VACT_NUM">
                        <div v-if="value.pg_result.P_VACT_NUM">계좌번호: {{ value.pg_result.P_VACT_NUM }}</div>
                        <div v-if="value.pg_result.P_FN_NM">은행명: {{ value.pg_result.P_FN_NM }}</div>
                        <!--                        <div v-if="value.pg_result.P_OID">이니시스 주문번호: {{ value.pg_result.P_OID }}</div>-->
                        <div v-if="value.pg_result.P_VACT_DATE">
                          입금 기한: {{ convertDate(value.pg_result.P_VACT_DATE, 'date') }}까지</div>
                      </td>

                    </tr>
                    <tr>
                      <td class="order-info-title">결제(입금자)</td>
                      <td>{{ value.name }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- 취소 상태 변경 -->
              <div v-if="showPayStatusChangeDiv">
                <div class="flex align-center" style="background-color: #eee; padding: 8px">
                  <span></span>
                  <span class="select" style="margin-left: 8px">
                    <select v-model="cancelStatus" @change="e => cancelStatus=parseInt(e.target.value)">
                      <option value="" disabled selected>취소 상태 변경</option>
                      <option :value="item.value" v-for="(item, idx) in cancel_status_arr" :key="'status-'+idx">{{ item.label }}</option>
                    </select>
                  </span>
                  <input class="input full has-text-right"
                         style="margin-left: 8px; width:250px"
                         v-model="cancelPrice"
                         @input="setCancelPrice"
                         v-if="cancelStatus===506"
                         type="number">
                  <button class="button" style="margin-left:8px"
                          @click="openCancelModal">취소하기</button>
                </div>
              </div>
            </admin-box-item>
          </div>
        </div>

        <div class="column is-full">
          <div class="box">
            <admin-box-item title="배달 정보">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item :isFlex="true" label="수령자명">{{ value.delivery.name }}</admin-form-item>
                  <admin-form-item :isFlex="true" label="수령자 휴대전화">{{ value.delivery.phone }}</admin-form-item>
                  <admin-form-item :isFlex="true" label="수령자 일반전화">{{ value.delivery.tphone }}</admin-form-item>
                  <admin-form-item :isFlex="true" label="배달주소">{{ value.delivery.address }}</admin-form-item>
                  <admin-form-item :isFlex="true" label="배달담당자">
                    <div class="flex-align">
                        <span class="select" style="margin-right:4px;">
                          <select v-model="value.delivery_manager.id"
                                  @change="e => value.delivery_manager.id=e.target.value">
                            <option value="" disabled selected>선택</option>
                            <option :value="item.value" v-for="(item, idx) in deliveryManagerList"
                                    :key="'manager-'+idx">{{ item.label }}</option>
                          </select>
                        </span>
                      <button class="button half" @click="saveDeliveryManager">저장</button>
                    </div>
                  </admin-form-item>
                  <admin-form-item :isFlex="true" label="배달메모">{{ value.delivery.memo }}</admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
        </div>
      </div>
    </div>

    <!-- 전체 취소 모달 -->
    <modal name="allCancelModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        전체 취소 하시겠습니까?
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="confirmCancel">확인</button>
        </div>
      </div>
    </modal>

    <!-- 부분 취소 모달 -->
    <modal name="partCancelModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        부분 취소 하시겠습니까?
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="confirmCancel">확인</button>
        </div>
      </div>
    </modal>

    <!-- 환불 철회 모달 -->
    <modal name="cancelRefundModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="반품 요청 철회" :useTab="false" class="lp-modal-wrapper">
        <div>반품 요청을 철회하면 이전 상태로 돌아갑니다. 철회 하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelRefundModal')">취소</button>
          <button class="button is-primary" @click="confirmModal('cancelRefundModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>

    <!-- 환불 모달 -->
    <modal name="refundModal" :adaptive="true" :width="800" height="auto" class="modal-style">
      <order-refund class="lp-modal-wrapper"
                    :order="value"
                    :order_product_list="order_product"
                    :refund_id="selectedRefundId"
                    @confirm="confirm('refundModal')"
                    @close="$modal.hide('refundModal')"></order-refund>
    </modal>

<!--  주문 취소 모달  -->
    <modal name="orderDetailCancelModal" :adaptive="true" :width="800" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="주문 취소">
          <table class="delivery-orderproduct-table">
            <thead>
            <tr>
              <th style="width:5%">
                <lp-check-bool :checkedVal.sync="check" @onCheck="clickCheckBoxAll"></lp-check-bool>
              </th>
              <th style="width:20%">상품 주문 번호</th>
              <th style="width:35%">주문 상품</th>
              <th style="width:10%">상품 금액</th>
              <th style="width:10%">수량</th>
              <th style="width:10%">상품별 금액</th>
              <th style="width:10%">할인 금액</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(op,idx) in order_product" :key="'op-'+idx" v-if="op.status<=302">
              <td style="width:5%">
                <lp-check-bool
                  v-if="showCheckBox(idx, op.status)"
                  @onCheck="selectOrderProduct"
                  :checkedVal.sync="checkArr[idx].value"></lp-check-bool>
              </td>
              <td style="width:20%">{{ op.id }}</td>
              <td style="width:35%">
                <div class="flex">
                  <img :src="op.product.img" style="width:35px;height:35px;margin-right:6px" v-if="op.product.img">
                  <div style="text-align: left">
                    <div v-if="op.order_product_option.length>0">
                      <div>{{ op.product.name }}</div>
                      <div style="color:#C1C1C1;font-size:14px"
                           v-for="(option, option_idx) in op.order_product_option"
                           :key="'option-'+option_idx">
                        <span v-if="option.option.option_type===0">기본옵션:</span>
                        <span v-if="option.option.option_type===1">추가옵션:</span>
                        {{ option.option.name }} {{ option.option.price | currency }} X {{ option.quantity }}
                      </div>
                    </div>
                    <div v-else>
                      {{ op.product.name }} {{ op.quantity }}개
                    </div>
                  </div>
                </div>

              </td>
              <td style="width:10%">{{ op.product_price | currency }}</td>
              <td style="width:10%">{{ op.quantity }}</td>
              <td style="width:10%">{{ op.product_price * op.quantity | currency }}</td>
              <td style="width:10%">{{ op.discount_price | currency }}</td>
            </tr>
            </tbody>
          </table>
        </admin-box-item>

        <div class="btn-group-justify-end">
          <button class="button" @click="$modal.hide('orderDetailCancelModal')">취소</button>
          <button class="button is-primary" @click="showCancelConfirmModal">확인</button>
        </div>
      </div>
    </modal>

    <modal name="cancelConfirmModal" :adaptive="true" :width="800" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div>주문 취소를 하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button" @click="$modal.hide('cancelConfirmModal')">취소</button>
          <button class="button is-primary" @click="cancelOrderProduct">확인</button>
        </div>
      </div>
    </modal>

    <modal-confirm :count="selectedValue.selected.length" @confirm="confirmStatusChange" @closeModal="closeModal"></modal-confirm>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import OrderRefund from "../components/OrderRefund";
  import MartMixin from "@/mixins/MartMixin"
  import Tab from "../../../module/common/Tab";
  import RefundInfo from "../components/RefundInfo";
  import ModalConfirm from "../components/ModalConfirm";
  import moment from 'moment';
  import html2canvas from 'html2canvas'

  export default {
    components: {
      ModalConfirm,
      RefundInfo,
      Tab,
      OrderRefund,
      LpCheckBool},
    name: "order-detail",
    mixins: [
      MartMixin
    ],
    data() {
      return {
        value: undefined,
        // tableItems: 원본, order_product: 원본에서 필터링 된 것
        order_product: [],
        calcTotalPrice: 0,
        calcDiscountPrice: 0,
        calcProductPrice: 0,
        calcQuantity: 0,
        check: false,
        // 일괄로 변경할 상태
        status: 0,
        status_arr: [],
        // 취소할 상태
        cancelStatus:0,
        cancel_status_arr: [
          {label:'전체취소',value:500},
          {label:'부분취소',value:506},
        ],
        // 부분 취소할 금액
        cancelPrice: 0,
        optionArr: [],
        tab: 0,
        start_status: 0,
        end_status: 0,
        selectedRefundId: 0,
        // 선택된 주문 상품
        selectedOrderProduct: [],
        partnerName: '',
        deliveryManagerArr: []
      }
    },
    created() {
      this.getDetail();
      this.getStatusList();
      this.getDeliveryManager();
    },
    computed: {
      enableCancelButton () {
        if(this.$route.query.page==='OrderListOrder' || this.$route.query.page==='OrderListPayNew') return true;
        else return false;
      },
      deliveryManagerList () {
        let manager_list = [];
        this.deliveryManagerArr.forEach(item => {
          if(item.partner_id===this.value.partner_id) {
            manager_list.push(item);
          }
        });
        return manager_list;
      },
      isDeliverySuccess () {
        let enable = false;
        this.order_product.forEach(item => {
          // 배달 완료 상태일 경우 활성화
          if(item.status===302) {
            enable = true;
          }
        })
        return enable;
      },
      // 환불 정보 입력 버튼 활성화 여부
      isRefunding () {
        let enable = false;
        this.order_product.forEach(item => {
          // 반품 검사중 상태일 경우 활성화
          if(item.status===702 || item.status===703) {
            enable = true;
          }
        })
        return enable;
      },
      isRefundPage () {
        let page = this.$route.query.page;
        let page_list = ['OrderListRefundAll', 'OrderListRefundNew', 'OrderListReturnAll',
          'OrderListReturning', 'OrderListReturnNew'];
        return page_list.indexOf(page) > -1;
      },
      showPayStatusChangeDiv () {
        // 전체 취소했을 경우는 비활성화
        if(this.value.is_cancel_all) return false;
        else if(this.value.total_price===this.value.cancel_price) {
          return false;
        }
        if(this.isCard) {
          // 전체 취소 또는 환불 없음 상태 노출 안함
          return !(this.value.is_cancel_all || this.value.no_refund);
        }
        else {
          return false;
        }
      },
      // 카드 결제 유무
      isCard() {
        return this.value.pay_type === 0 || this.value.pay_type===3;
      },
      payDate() {
        let date = '';
        if(this.value.pg_result.applDate) {
          date = `${this.value.pg_result.applDate} ${this.value.pg_result.applTime}`;
          return moment(date).format('YYYY-MM-DD HH:mm:ss');
        }
        else {
          date = this.value.pg_result.P_AUTH_DT
          return date
        }
      },

    },
    methods: {
      openRefundModal () {
        let enable_cancel = this.order_product.some(item => {
          return (item.status>=500 && item.status<=501)
        })
        if (enable_cancel) {
          this.$modal.show('refundModal');
        }
        else {
          this.toast('환불 처리 가능한 주문이 없습니다.')
        }
      },
      getDeliveryManager() {
        this.$axios.get('public/mart/delivery_manager').then(res => {
          this.deliveryManagerArr = res.data;
        })
      },
      saveDeliveryManager() {
        if(!this.value.delivery_manager.id) {
          this.toast('배달 담당자를 선택하고 저장해주세요');
          return;
        }
        let url = this.getUrl('mart/delivery_manager/select');
        this.$axios.post(url, {
          order_id: this.value.id,
          delivery_manager_id: this.value.delivery_manager.id
        }).then(res => {
          if(res.status===200) {
            this.toast('저장되었습니다');
            this.getData();
          }
        })
      },
      getPartnerDetail () {
        this.$axios.get(this.getUrl(`partner/${this.value.partner_id}`)).then(res => {
          if(res.status===200) {
            this.partnerName = res.data.partner.name;
          }
        })
      },
      showCheckBox (idx, status) {
        if(this.checkArr[idx]!==undefined && this.tab===0 && !(status>=500 && status<=504) ) {
          return true;
        }
        else if(this.checkArr[idx]!==undefined && this.tab===1) {
          return true;
        }
        else {
          return false;
        }
      },
      changeStatus (status) {
        this.status = parseInt(status);
        let selected = [];
        this.order_product.forEach(item => {
          selected.push(item.id);
        })
        this.selectedValue = {
          selected: selected,
          status: this.status
        };
        this.$modal.show(this.getStatusName(this.status));
        /*let id_list = this.getCheckedArr();
        let is_cancel_item = this.tableItems.some(item => {
          return id_list.indexOf(item.id) > -1 && item.status>=500 && item.status<=504;
        });
        if(is_cancel_item) {
          this.toast('이미 취소된 주문 상품은 ' + this.getStatusName(status) + ' 상태로 변경이 불가합니다.');
        }*/

      },
      showCancelConfirmModal() {
        if(this.getCheckedArr().length>0) {
          this.$modal.show('cancelConfirmModal');
        } else {
          this.toast('취소할 상품을 선택해주세요.');
        }
      },
      // 주문 취소
      cancelOrderProduct () {
        let status = 500;
        let selected_id_list = this.getCheckedArr();
        let url = `mart/orderproduct/status/change/multiple`;
        this.$axios.post(this.getUrl(url), {
          status: status,
          checked: selected_id_list
        }).then(res => {
          if(res.status===200) {
            this.getDetail();
            this.$modal.hide('orderDetailCancelModal');
            this.$modal.hide('cancelConfirmModal')
            this.toast('주문 취소 처리가 완료 되었습니다.');
          }
        }).catch(error => {
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      },
      // 주문 상품 선택
      selectOrderProduct () {
        let id_list = this.getCheckedArr();
        let selected = [];
        for(let i=0; i<id_list.length; i++) {
          let op = find(this.order_product, 'id', id_list[i]);
          // console.log(op)
          if(op) selected.push(op);
        }
        this.selectedOrderProduct = selected;
      },
      // 반품 접수
      requestRefund() {
        this.status = 700;
        this.clickChange();
      },
      selectTab (value) {
        this.tab = value;
        let tableItems = [];
        // 교환 예외처리
        if(this.tab!==2) {
          this.selectedOrderProduct = [];
        }
        // 전체
        if(this.tab===0) {
          this.start_status = 0;
          this.end_status = 1000;
        }
        // 취소
        else if(this.tab===1) {
          this.start_status = 500;
          this.end_status = 504;
        }
        // 교환
        else if(this.tab===2) {
          this.start_status = 600;
          this.end_status = 609;
        }
        tableItems = this.tableItems.filter(item => {
          if(this.tab===0) {
            return (item.status>=this.start_status &&item.status<=this.end_status)
              && !(item.status>=500 && item.status<=504)
          }
          else {
            return item.status>=this.start_status &&item.status<=this.end_status
          }
        })
        this.order_product = tableItems;
        let checkArr = [];
        for (let i = 0; i < this.order_product.length; i++) {
          checkArr.push({id: this.order_product[i].id, value: false})
        }
        this.checkArr = checkArr;
        this.calcTotal();
      },
      confirm (modal_name) {
        this.getDetail();
        this.$modal.hide(modal_name);
      },
      // 상태값 목록
      getStatusList(){
        let page = this.$route.query.page;
        if(!page) return;
        this.$axios.get(this.getUrl(`mart/order/status?page=${page}`)).then(res=>{
          if(res.status === 200){
            this.status_arr = res.data;
          }
        })
      },
      // 체크박스 일괄 선택
      clickCheckBoxAll(value) {
        this.checkArr.forEach(item => {
          item.value = value;
        })

        this.selectOrderProduct();

      },
      getDetail() {
        this.$axios.get(this.getUrl(`mart/order/${this.$route.query.id}`)).then(res=> {
          this.value = res.data;
          let tableItems = res.data.order_product;
          let tableList = [];
          for(let i = 0; i < tableItems.length; i++) {
            tableList.push({id: tableItems[i].id, value: false});
          }
          this.checkArr = tableList;
          this.order_product = tableItems;
          // tableItems: 원본 데이터
          // order_product: tableItems를 필터링한 데이터
          this.tableItems = tableItems;

          this.selectTab(0);
          /*if(this.isCard) {
            let status = find(this.status_arr, 'value', 504);
            if(status===undefined) this.status_arr.push({label:'취소완료(환불완료)',value:504});
          }
          else {
            let status = find(this.status_arr, 'value', 503);
            if(status===undefined) this.status_arr.push({label:'취소완료(입금전 주문취소)',value:503});
          }*/

          // tabArr 초기화
          let cancel_count = 0;
          for(let x=0; x<this.tableItems.length; x++) {
            let op = this.tableItems[x];
            // 취소
            if(op.status>=500 && op.status<=504) {
              cancel_count += 1
            }
          }
          let tabArr = [];
          tabArr.push({label:`주문내역(${this.order_product.length})`, value: 0});
          tabArr.push({label:`취소(${cancel_count})`, value: 1});
          this.tabArr = tabArr;

          let page = this.$route.query.page;

          // 반품 페이지에서 넘어왔을 경우 반품 탭으로 이동
          if(page==='OrderListReturning' || page=== 'OrderListRefundNew') {
            this.selectTab(1);
            if(this.value.refund.length===0) {
              this.toast('반품할 상품을 추가 해주세요.');
            }
          }
          this.getPartnerDetail();

        })
      },
      calcTotal() {
        let total_price = 0;
        let discount_price = 0;
        let quantity = 0;
        let total_product_price = 0;
        this.order_product.forEach(op=> {
          quantity += op.quantity;
          discount_price += op.discount_price;
          total_price += op.total_price;
          total_product_price += op.product_price * op.quantity;
        })
        this.calcTotalPrice = total_price;
        this.calcDiscountPrice = discount_price;
        this.calcProductPrice = total_product_price;
        this.calcQuantity = quantity;
      },
      // 취소, 부분취소
      openCancelModal() {
        if(this.cancelStatus===500) {
          if(this.value.cancel_price>0) {
            this.toast('부분취소를 하여 전체취소가 불가능합니다.');
            this.$modal.hide('allCancelModal');
          }
          else this.$modal.show('allCancelModal');
        }
        else if(this.cancelStatus===506) {
          this.$modal.show('partCancelModal');
        }
      },
      // 부분 취소 금액 입력
      setCancelPrice(e) {
        let price = parseInt(e.target.value);
        this.cancelPrice = price;
      },
      confirmCancel() {
        // 전체 취소
        if(this.cancelStatus===500) {
          // let url = `http://localhost:8000/user/${this.user.user_id}/delivery/order/${this.card.id}/status/change`;
          let url = `mart/order/${this.$route.query.id}/status/change`;
          this.$axios.post(this.getUrl(url), {
            status: 504
          }).then(res=> {
            if(res.status===200) {
              this.toast('전체 취소가 완료되었습니다.');
              this.$modal.hide('allCancelModal');
              this.getDetail();
            }
          }).catch(error => {
            this.toast(error.response.data.message);
            this.$modal.hide('allCancelModal');
          });
        }
        // 부분 취소
        else if(this.cancelStatus===506) {
          let url = `mart/order/${this.$route.query.id}/cancelprice`;
          // let url = `http://localhost:8000/admin/delivery/order/${this.$route.query.id}/cancelprice`;
          this.$axios.post(this.getUrl(url), {
            cancel_price: this.cancelPrice
          }).then(res=> {
            if(res.status===200) {
              this.toast('부분 취소가 완료되었습니다.');
              this.$modal.hide('partCancelModal');
              this.getDetail();
            }
          }).catch(error=> {
            this.toast(error.response.data.message);
            this.$modal.hide('partCancelModal');
            this.getDetail();
          })
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .delivery-orderproduct-table
  .delivery-order-info
    width 100%

  .delivery-orderproduct-table th
    background-color #eee

  .delivery-orderproduct-table th
  .delivery-orderproduct-table td
  .delivery-order-info td
    text-align center !important
    border 1px solid #e0d9d9
    padding 6px
    vertical-align middle !important

  .delivery-orderproduct-table .table-result
    background-color #EBEAE4

  .delivery-order-info .order-info-title
  .order-info-title
    background-color #eee
</style>
